var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVotesPageBlockMobileFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 3.99984H11.3333L7.99333 8.19984L4.66666 3.99984ZM2.83333 3.73984C4.18 5.4665 6.66666 8.6665 6.66666 8.6665V12.6665C6.66666 13.0332 6.96666 13.3332 7.33333 13.3332H8.66666C9.03333 13.3332 9.33333 13.0332 9.33333 12.6665V8.6665C9.33333 8.6665 11.8133 5.4665 13.16 3.73984C13.5 3.29984 13.1867 2.6665 12.6333 2.6665H3.36C2.80666 2.6665 2.49333 3.29984 2.83333 3.73984Z",
    fill: "#363B4D",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotesPageBlockMobileFilterIcon);
export default __webpack_public_path__ + "static/media/VotesPageBlock_mobile_filter_icon.2994694eca938e0fd24b4a3594279176.svg";
export { ForwardRef as ReactComponent };